module.exports = __webpack_public_path__ + "static/img/20015 (3).b70737c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20015 (3).webp
// module id = ayYx
// module chunks = 14